module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privatnost",
	"footer.privacy.url": "https://www.grohe.hr/hr_hr/company/privacy/",
	"footer.disclaimer.text": "Odricanje",
	"footer.disclaimer.url": "https://www.grohe.hr/hr_hr/company/legal-info/",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Grohe Watersystems konfigurator",
	"homepage.introtext": "Samo odgovorite na nekoliko pitanja kako biste konfigurirali GROHE Water System koji će odgovarati vašim potrebama.",
	"homepage.buttonStart": "Početak",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 stranica nije pronađena",
	"404.link.goBack": " Vratite se na početnu stranicu",
	"configurator.button.seeResults": "Vidi rezultate",
	"question1.question": "Imate li hladnu i toplu vodu u svojoj kuhinji?",
	"question1.option1.text": "Imam hladnu i toplu vodu u mojoj kuhinji",
	"question1.option2.text": "Imam samo hladnu vodu",
	"question2.question": "Koju vrstu vode tražite?",
	"question2.option1.text": "vrelu vodu za pripremu hrane i pića",
	"question2.option2.text": "Rashlađena i pjenušava voda za piće",
	"question2.option3.text": "Rashlađena i pjenušava, ali i vrela voda",
	"question3.question": "Želite li zadržati postojeću kuhinjsku slavinu?",
	"question3.option1.text": "Želim je zadržati",
	"question3.option2.text": "Želim instalirati novi model",
	"question4.question": "Koja bi bila vaša glavna mješalica?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Koji je vaš željeni oblik izljeva?",
	"question5.option1.text": "Izljev u obliku slova L",
	"question5.option2.text": "Izljev u obliku slova U",
	"question5.option3.text": "Izljev u obliku slova C",
	"question6.question": "Koja je vaša željena završna obrada??",
	"question6.option1.text": "krom",
	"question6.option2.text": "Mat krom",
	"question7.question": "Koju veličinu bojlera trebate?",
	"question7.option1.text": "M veličina(3 litre)",
	"question7.option2.text": "Veličina L (5,5 litara)",
	"results.title": "{productGroupsCount, plural, \none {vaši rezultati} \nother {vaši rezultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Za ispravnu instalaciju također ćete trebati:",
	"results.newConfiguration.title": "Želite li konfigurirati novi vodeni sustav?",
	"results.newConfiguration.buttonText": "Konfiguriraj novi vodeni sistem",
	"results.product.number": "Broj proizvoda: #{number}",
	"results.product.button.productInformation": "Informacije o proizvodu",
	"results.product.button.dealerLocator": "Pronađite izložbeni prostor",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": " Informacije o proizvodu",
	"results.product.dealer": "Pronađite izložbeni prostor",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.hr_hr.json
// module id = 774
// module chunks = 0